const Regex = {
  latLong: /^-?([1-8]?[1-9]|[1-9]0)\\.{1}\\d{1,6}/,
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  charSpace: /^([a-zA-Z_ ]+)$/,
  numeric: /^\d+$/,
  text: /^[a-zA-Z .]+$/,
  number: /^\d+$/,
  phoneNumber: /[0-9]{10}/,
  pinCode: /^(\d{4}|\d{6})$/,
  alphaNumeric: /^[a-zA-Z0-9_ ]+$/,
  alphaNum: /^[a-zA-Z0-9 ]+$/,
  toFixed: /^(?:\d*\.\d{1,2}|\d+)$/,
  decimalNum: /^\d+\.\d{0,2}$/,
  numericNotZero: /^[+]?[1-9]\d*$/,
  twodecimal:/^(\d+|\d+\.\d{1,2})$/,
  // Milestone/retention % — allow legacy high-precision values (e.g. 80.53302433)
  percentage:/^(\d+|\d+\.\d{1,10})$/,
  textWithComma : /^[a-zA-Z,_ ]+$/,
  gstRegex : /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
};

export default Regex;
